// extracted by mini-css-extract-plugin
export default {"container":"DwpqJ83p3_","list":"zoBYlpi75a","buttonContainer":"PCirCJOkVs","button":"dnUXiXrZVx","avatar":"vwjwOvhx_3"};